<template>
    <div>
        <b-button @click="doClick()" :disabled="working">
            Force Complete
            <b-spinner v-if="working" small label="completing" />
        </b-button>
    </div>
</template>

<script>
export default {
    props: {
        recordingId: { type: String }
    },

    data() { 
        return {
            working: false
        }
    },

    methods: {
        doClick() {
            this.working = true;
            this.$emit('click');
        }
    }
}
</script>